import _ from 'lodash'
import settings from '../../../config/settings'

export default class PageUtils {
  static getTitle() {
    return _.get(settings, 'website.title')
  }
}
